export default "__VITE_ASSET__hJS4ypGR__"